import merge from 'lodash/merge';
import {twMerge} from '../../../common/twMerge';
import {MOBILE_HEADER_HEIGHT_PX} from '../../../header/constants';
import {TAB_POSITION_CONTROL_STICKY_Z_INDEX} from '../../atoms/TabPositionControl/constants';
import {SearchAutoCompleteWrapperProps} from './SearchAutoCompleteWrapperProps.interface';

export function SearchAutoCompleteWrapper({
  className,
  isMobile,
  children,
  style,
  ...props
}: SearchAutoCompleteWrapperProps) {
  return (
    <div
      className={twMerge(
        isMobile
          ? 'fixed w-full overflow-y-auto bg-theme-bg-base px-15pxr'
          : 'w-272pxr rounded-8pxr border-1 border-theme-transparent-10 p-12pxr',
        className
      )}
      style={merge(
        isMobile
          ? {
              zIndex: TAB_POSITION_CONTROL_STICKY_Z_INDEX + 1,
              top: MOBILE_HEADER_HEIGHT_PX,
              height: `calc(100% - ${MOBILE_HEADER_HEIGHT_PX}px)`,
            }
          : {
              boxShadow: '4px 6px 15px rgba(0, 0, 0, 0.12)',
            },
        style
      )}
      {...props}
    >
      {children}
    </div>
  );
}
